import React, {createContext, useContext, useMemo, useState} from 'react';

type PanelBankSectionsScrollContextProviderProps = {
  children: React.ReactNode;
};

type PanelBankSectionsScrollContextType = {
  scrollToPanelBankSectionId: string | undefined;
  setScrollToPanelBankSectionId: React.Dispatch<
    React.SetStateAction<string | undefined>
  >;
};

const PanelBankSectionsScrollContext = createContext<
  PanelBankSectionsScrollContextType | undefined
>(undefined);

export const PanelBankSectionsScrollContextProvider = ({
  children,
}: PanelBankSectionsScrollContextProviderProps) => {
  const [scrollToPanelBankSectionId, setScrollToPanelBankSectionId] = useState<
    string | undefined
  >(undefined);

  const value = useMemo(
    () => ({
      scrollToPanelBankSectionId,
      setScrollToPanelBankSectionId,
    }),
    [scrollToPanelBankSectionId, setScrollToPanelBankSectionId]
  );

  return (
    <PanelBankSectionsScrollContext.Provider value={value}>
      {children}
    </PanelBankSectionsScrollContext.Provider>
  );
};

export const usePanelBankSectionsScrollContext = () => {
  const value = useContext(PanelBankSectionsScrollContext);

  if (value == null) {
    throw new Error(
      'usePanelBankSectionsScrollContext must be used within a PanelBankSectionsScrollContext'
    );
  }

  return value;
};
